export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    title: that.$l('table_label_delivery') || '最早出货日期',
    field: 'deliveryDate',
    headerAlign: 'center',
    align: 'center',
    minWidth: 120,
  },
  {
    title: that.$l('table_label_deliveryQty') || '出货产品数量',
    field: 'deliveryQty',
    headerAlign: 'center',
    align: 'center',
    minWidth: 130,
    isTotalColumn: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_unitInvQty') || '出货前已有成品库存',
    field: 'unitInvQty',
    headerAlign: 'center',
    align: 'center',
    minWidth: 170,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_earliestShipDate') || '最早可出货日期',
    field: 'earliestShipDate',
    headerAlign: 'center',
    align: 'center',
    minWidth: 170,
  },
  {
    title: that.$l('table_label_matchResult') || '是否可以正常出货',
    field: 'matchResult',
    headerAlign: 'center',
    align: 'center',
    minWidth: 130,
    slots: { default: 'matchResult' },
  },
]
